<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="section-title">Exact Retention</div>
            <div class="section-hint">نرخ وزنی cohortهای mature. روزی که هنوز نرسیده خالی می‌ماند.</div>
            <div class="row mb-4">
              <div v-for="kpi in exactKpiCards" :key="kpi.key" class="col-xl-3 col-md-4 col-sm-6 mb-3">
                <div class="metric-card">
                  <div class="metric-card-label">{{ kpi.label }}</div>
                  <div class="metric-card-value">{{ kpi.value }}</div>
                </div>
              </div>
            </div>
            <highcharts class="f-chart" :options="chartOptionsRetention"></highcharts>

            <div class="section-title mt-4">Return Window</div>
            <div class="section-hint">حداقل یک بازگشت داخل بازه. هر کاربر فقط یک بار شمرده می‌شود.</div>
            <div class="row mb-4">
              <div v-for="kpi in windowKpiCards" :key="kpi.key" class="col-xl-3 col-md-4 col-sm-6 mb-3">
                <div class="metric-card">
                  <div class="metric-card-label">{{ kpi.label }}</div>
                  <div class="metric-card-value">{{ kpi.value }}</div>
                </div>
              </div>
            </div>
            <highcharts class="f-chart" :options="chartOptionsRetentionWindow"></highcharts>
            <hr />

            <div class="row mb-4">
              <div v-for="kpi in kpiCards" :key="kpi.key" class="col-xl-3 col-md-4 col-sm-6 mb-3">
                <div class="metric-card">
                  <div class="metric-card-label">{{ kpi.label }}</div>
                  <div class="metric-card-value">{{ kpi.value }}</div>
                </div>
              </div>
            </div>
            <highcharts class="f-chart" :options="chartOptionsAvgMatches"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsSecondMatch"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsAdEngagement"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsStoreOpen"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsPurchase"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptions"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsLeague"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsMasterLeague"></highcharts>
            <hr />
            <highcharts class="f-chart" :options="chartOptionsUsers"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statysticService from '../../../services/statystic';
import retentionService from '../../../services/retention';
import metricsService from '../../../services/metrics';
import { Chart } from 'highcharts-vue';
import moment from 'moment';

const RETENTION_DAYS = 60;

const EXACT_SERIES = [
  { key: 'd1', field: 'd1Retention', name: 'D1' },
  { key: 'd3', field: 'd3Retention', name: 'D3' },
  { key: 'd7', field: 'd7Retention', name: 'D7' },
  { key: 'd30', field: 'd30Retention', name: 'D30' },
];

const WINDOW_SERIES = [
  { key: 'returnedD1ToD3', field: 'returnedD1ToD3Retention', name: 'D1–D3' },
  { key: 'returnedD1ToD7', field: 'returnedD1ToD7Retention', name: 'D1–D7' },
  { key: 'returnedD4ToD7', field: 'returnedD4ToD7Retention', name: 'D4–D7' },
  { key: 'returnedD1ToD30', field: 'returnedD1ToD30Retention', name: 'D1–D30' },
];

function retentionChartOptions(title, series) {
  return {
    series: series.map((item) => ({ data: [], name: item.name })),
    title: { text: title },
    yAxis: {
      title: { text: 'درصد' },
      max: 100,
      min: 0,
    },
    tooltip: {
      shared: true,
      valueDecimals: 1,
      valueSuffix: '%',
    },
    xAxis: { type: 'datetime' },
  };
}

function percentChartOptions(title) {
  return {
    series: [{ data: [], name: title }],
    title: { text: title },
    yAxis: {
      title: { text: 'درصد' },
      max: 100,
      min: 0,
    },
    tooltip: {
      valueDecimals: 1,
      valueSuffix: '%',
    },
    xAxis: { type: 'datetime' },
  };
}

function countChartOptions(title) {
  return {
    series: [{ data: [], name: title }],
    title: { text: title },
    yAxis: { title: { text: 'تعداد' } },
    xAxis: { type: 'datetime' },
  };
}

export default {
  name: 'index',
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      exactKpiCards: [],
      windowKpiCards: [],
      kpiCards: [],
      chartOptions: {
        series: [{ data: [], name: 'TOTAL' }, { data: [], name: 'AI' }],
        title: { text: 'بازی های انجام شده' },
        xAxis: { type: 'datetime' },
        yAxis: { title: { text: 'تعداد' } },
      },
      chartOptionsLeague: {
        series: [{ data: [], name: 'TOTAL' }, { data: [], name: 'AI' }],
        title: { text: 'بازی های لیگ' },
        xAxis: { type: 'datetime' },
        yAxis: { title: { text: 'تعداد' } },
      },
      chartOptionsMasterLeague: {
        series: [{ data: [], name: 'TOTAL' }],
        title: { text: 'بازی های مستر لیگ' },
        xAxis: { type: 'datetime' },
        yAxis: { title: { text: 'تعداد' } },
      },
      chartOptionsUsers: {
        series: [{ data: [], name: '' }],
        title: { text: 'کاربر های جدید' },
        xAxis: { type: 'datetime' },
        yAxis: { title: { text: 'تعداد' } },
      },
      chartOptionsRetention: retentionChartOptions('بازگشت دقیق', EXACT_SERIES),
      chartOptionsRetentionWindow: retentionChartOptions('بازگشت در بازه', WINDOW_SERIES),
      chartOptionsAvgMatches: countChartOptions('میانگین بازی به ازای هر کاربر'),
      chartOptionsSecondMatch: percentChartOptions('نرخ تبدیل بازی دوم'),
      chartOptionsAdEngagement: percentChartOptions('تعامل تبلیغ پاداش‌دار'),
      chartOptionsStoreOpen: percentChartOptions('نرخ باز شدن فروشگاه'),
      chartOptionsPurchase: percentChartOptions('نرخ تبدیل خرید'),
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const [data, retentionData, metricsData] = await Promise.all([
          statysticService.getMainData(),
          retentionService.getRetentionChart(RETENTION_DAYS),
          metricsService.getDashboardMetrics(30),
        ]);

        this.daily(data.allGamesMonth, this.chartOptions, 0);
        this.daily(data.fakeGamesMonth, this.chartOptions, 1);
        this.daily(data.allGamesMonthLeague, this.chartOptionsLeague, 0);
        this.daily(data.fakeGamesMonthLeague, this.chartOptionsLeague, 1);
        this.daily(data.allMasterLeagueGamesMonth, this.chartOptionsMasterLeague, 0);
        this.daily(data.getNewUsers, this.chartOptionsUsers, 0);

        this.retentionChart(retentionData.cohorts, this.chartOptionsRetention, EXACT_SERIES);
        this.retentionChart(retentionData.cohorts, this.chartOptionsRetentionWindow, WINDOW_SERIES);
        this.daily(metricsData.avgMatchesPerUser, this.chartOptionsAvgMatches, 0);
        this.daily(metricsData.secondMatchConversion, this.chartOptionsSecondMatch, 0, true);
        this.daily(metricsData.rewardedAdEngagement, this.chartOptionsAdEngagement, 0, true);
        this.daily(metricsData.storeOpenRate, this.chartOptionsStoreOpen, 0, true);
        this.daily(metricsData.purchaseConversion, this.chartOptionsPurchase, 0, true);

        this.buildKpiCards(retentionData.summary || {}, metricsData);
      } catch (error) {
        console.log(error);
      }
    },

    buildKpiCards(summary, metricsData) {
      this.exactKpiCards = EXACT_SERIES.map((item) => ({
        key: item.key,
        label: item.name,
        value: this.formatPercent(summary[item.field]),
      }));
      this.windowKpiCards = WINDOW_SERIES.map((item) => ({
        key: item.key,
        label: item.name,
        value: this.formatPercent(summary[item.field]),
      }));
      this.kpiCards = [
        {
          key: 'avgMatches',
          label: 'Average Matches Per User',
          value: this.formatNumber(this.getLatestValue(metricsData.avgMatchesPerUser)),
        },
        {
          key: 'secondMatch',
          label: 'Second Match Conversion',
          value: this.formatPercent(this.getLatestValue(metricsData.secondMatchConversion, true)),
        },
        {
          key: 'adEngagement',
          label: 'Rewarded Ad Engagement',
          value: this.formatPercent(this.getLatestValue(metricsData.rewardedAdEngagement, true)),
        },
        {
          key: 'storeOpen',
          label: 'Store Open Rate',
          value: this.formatPercent(this.getLatestValue(metricsData.storeOpenRate, true)),
        },
        {
          key: 'purchase',
          label: 'Purchase Conversion',
          value: this.formatPercent(this.getLatestValue(metricsData.purchaseConversion, true)),
        },
      ];
    },

    getLatestValue(series, allowNull = false) {
      if (!series?.length) return null;

      for (let i = series.length - 1; i >= 0; i--) {
        const value = series[i].total;
        if (allowNull && value == null) continue;
        if (value != null) return value;
      }

      return null;
    },

    formatPercent(value) {
      if (value == null) return '—';
      return `${(value * (value <= 1 ? 100 : 1)).toFixed(1)}%`;
    },

    formatNumber(value) {
      if (value == null) return '—';
      return Number(value).toFixed(2);
    },

    retentionChart(cohorts, chartOptions, series) {
      const chartDate = [];
      const seriesData = series.map(() => []);

      for (let index = 0; index < cohorts.length; index++) {
        const cohort = cohorts[index];
        const date = moment(cohort.cohortDay).format('YYYY-MM-DD');
        chartDate.push(new Date(date).toLocaleDateString('fa-IR'));
        series.forEach((item, seriesIndex) => {
          const value = cohort[item.field];
          seriesData[seriesIndex].push(value != null ? value * 100 : null);
        });
      }

      seriesData.forEach((data, seriesIndex) => {
        chartOptions.series[seriesIndex].data = data;
      });

      chartOptions.xAxis = {
        tickInterval: 1,
        labels: {
          enabled: true,
          formatter: function(x) {
            return chartDate[x.value];
          },
        },
      };
    },

    daily(lastMonth, chartOptions, serieIndex, allowNull = false) {
      const chartData = [];
      const chartDate = [];

      for (let index = 0; index < lastMonth.length; index++) {
        const value = lastMonth[index].total;
        chartData.unshift(allowNull && value == null ? null : value);
        const date = moment(lastMonth[index].date).format('YYYY-MM-DD');
        const dateStr = new Date(date).toLocaleDateString('fa-IR');
        chartDate.unshift(dateStr);
      }

      chartOptions.series[serieIndex].data = chartData;
      chartOptions.xAxis = {
        tickInterval: 1,
        labels: {
          enabled: true,
          formatter: function(x) {
            return chartDate[x.value];
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.section-title {
  color: #2e59d9;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.section-hint {
  color: #5a5c69;
  font-size: 13px;
  margin-bottom: 12px;
}

.metric-card {
  background: #f8f9fc;
  border: 1px solid #e4e8f0;
  border-radius: 8px;
  padding: 16px;
  height: 100%;
}

.metric-card-label {
  color: #5a5c69;
  font-size: 13px;
  margin-bottom: 8px;
}

.metric-card-value {
  color: #2e59d9;
  font-size: 24px;
  font-weight: 700;
}
</style>
